// Keep the page quiet until a visitor chooses a video.
const videos = document.querySelectorAll('video');
videos.forEach(video => video.addEventListener('play', () => {
  videos.forEach(other => { if (other !== video) other.pause(); });
}));
